import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Débit depuis le moyen de paiement',
    [BillingMode.InternalInvoicing]: 'Débit depuis les ventes',
    active: 'Actif',
    on_trial: 'En essai',
    launch_pending: "En attente jusqu'à la date de lancement",
    billing_disabled: 'Facturation désactivée',
    on_grace_period: 'En période de grâce',
    past_due: 'En retard',
    cancelled: 'Annulé',
  },
};
